import Pagination from './src/Pagination';

export default Pagination;
